<header class="header">
    <fa-icon class="icon" icon="file-signature" [fixedWidth]="true"></fa-icon>
    <div class="dark-theme title">
        <mat-form-field
            *ngIf="IsSearching$.value; else header"
            [style.width]="IsSmallWidth$.value ? '100%' : '50%'"
            color="accent"
            floatLabel="never"
        >
            <mat-label>Suche nach Verträgen</mat-label>
            <input matInput [formControl]="InputForm" #input />
            <button class="clear-search" *ngIf="InputForm.value" (click)="InputForm.setValue('')" mat-icon-button matSuffix>
                <fa-icon icon="times" [fixedWidth]="true" class="suffix"></fa-icon>
            </button>
        </mat-form-field>
    </div>

    <ng-template #header>
        <h3>Vertragsliste</h3>
    </ng-template>

    <button
        (click)="IsSearching$.next(!IsSearching$.value)"
        [matTooltip]="IsSearching$.value ? 'Suche schließen' : 'Suchen'"
        matTooltipPosition="left"
        app-round-button
        class="button"
        Inverted
    >
        <fa-icon [icon]="IsSearching$.value ? 'times' : 'search'"></fa-icon>
    </button>

    <a
        [routerLink]="['/', 'vertraege', 'neuerVertrag']"
        matTooltip="Vertrag hinzufügen"
        matTooltipPosition="left"
        app-round-button
        class="button"
        Inverted
    >
        <fa-icon icon="plus"></fa-icon>
    </a>
</header>

<!-- Klasse nur für den inset box shadow -->
<ngx-simplebar  class="clickable-list-container">
    <table mat-table [dataSource]="DataSource$ | async" matSort>
        <ng-container *ngFor="let column of Columns" [matColumnDef]="column.name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ column.header }}</th>
            <td mat-cell *matCellDef="let rowData">{{ rowData[column.name] }}</td>
        </ng-container>

        <ng-container matColumnDef="chevron">
            <!-- Inline-Style: Breite des Icons -->
            <th mat-header-cell *matHeaderCellDef style="width: 11px;"></th>
            <td mat-cell *matCellDef><fa-icon icon="chevron-right"></fa-icon></td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="DisplayedColumns$ | async"></tr>
        <tr
            mat-row
            *matRowDef="let rowData; columns: DisplayedColumns$ | async"
            [routerLink]="rowData.RouterLink"
            routerLinkActive="active"
        ></tr>
    </table>
</ngx-simplebar>
